<template>
    <div class="options">
        <div v-if="showActive">
            <select class="select-base" @change="activeChange" v-model="activeOnly">
                <option value="all">Tout afficher</option>
                <option value="active">Actif uniquement</option>
            </select>
        </div>
        <div class="searchBar">
            <input type=search :placeholder="placeholder || 'Recherche rapide'" v-model="search"
                   @search="$emit('search',search)" @input="$emit('search',search)"/>
            <button>
                <svg class="option">
                    <use xlink:href="#icon-zoom"></use>
                </svg>
            </button>
        </div>
        <div class="searchBar" v-if="limit > 0">
            <label for="limit">Affichage :</label>
            <input type="text" id="limit" placeholder="Affichage" @keyup="$emit('change',limitValue)"
                   v-model="limitValue"/>
        </div>
    </div>
</template>

<script>

export default {
    name: "SearchBar",
    props: {
        placeholder: "",
        value: "",
        limit: 0,
        active:true,
        showActive: false,
    },
    data() {
        return {
            search: "",
            limitValue: 0,
            activeOnly:this.active?"active":"all",
        }
    },
    watch: {
        limit() {
            this.limitValue = this.limit;
        },
        value() {
            this.search = this.value;
        }
    },
    methods: {
        activeChange($event) {
            // console.log($event.target.value)
            this.$emit('activeChange', $event.target.value)
        }
    },
    mounted() {
        this.limitValue = this.limit;
    }
}
</script>
